__webpack_require__.p = "https://q-fe.aixuexi.com/axx-teaching/aixuexi-B-train/";